// File: pages/Admin/Dashboard.js

import React, { useState, useEffect } from 'react';
import axios from '../../axios';
import {
  Box,
  Container,
  Typography,
  Card,
  CardContent,
  Grid,
  IconButton,
  Tooltip,
  Menu,
  MenuItem
} from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import CollectionsIcon from '@mui/icons-material/Collections';
import ArticleIcon from '@mui/icons-material/Article';
import WorkIcon from '@mui/icons-material/Work';
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';

const Dashboard = () => {
  const [galleryCount, setGalleryCount] = useState(0);
  const [blogsCount, setBlogsCount] = useState(0);
 

  useEffect(() => {
    const fetchCounts = async () => {
      try {
        const [galleryRes, blogRes, projectRes] = await Promise.all([
          axios.get('/gallery_management.php'),
          axios.get('/blog_management.php'),
         
        ]);

        setGalleryCount(galleryRes.data.length);
        setBlogsCount(blogRes.data.length);
        
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchCounts();
  }, []);

  return (
    <Container sx={{ mt: 10 }}>
      <HeaderPaper elevation={0}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <DashboardIcon sx={{ fontSize: 32, color: 'primary.main', mr: 2 }} />
            <Box>
              <Typography variant="h4" sx={{ fontWeight: 600, color: 'text.primary', mb: 1 }}>
                Dashboard Overview
              </Typography>
              <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 800 }}>
                Monitor and manage your organization's digital content. View real-time statistics of your gallery items and blog posts.
              </Typography>
            </Box>
          </Box>
          <ProfileMenu />
        </Box>
      </HeaderPaper>

      <Grid container spacing={4}>
        <Grid item xs={12} sm={6} md={4}>
          <StyledCard>
            <CardContent>
              <CollectionsIcon sx={{ fontSize: 40, color: 'primary.main', mb: 1 }} />
              <Typography variant="h6">Gallery Items</Typography>
              <Typography variant="h4" color="primary">{galleryCount}</Typography>
            </CardContent>
          </StyledCard>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <StyledCard>
            <CardContent>
              <ArticleIcon sx={{ fontSize: 40, color: 'primary.main', mb: 1 }} />
              <Typography variant="h6">Blog Posts</Typography>
              <Typography variant="h4" color="primary">{blogsCount}</Typography>
            </CardContent>
          </StyledCard>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          
        </Grid>
      </Grid>
    </Container>
  );
};

const HeaderPaper = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(4),
}));

const StyledCard = styled(Card)(({ theme }) => ({
  padding: theme.spacing(3),
  borderRadius: theme.spacing(2),
  textAlign: 'center',
  transition: 'transform 0.3s ease',
  '&:hover': {
    transform: 'translateY(-5px)',
  },
}));

const ProfileMenu = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();

  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleSettingsClick = () => {
    handleCloseMenu();
    navigate('/admin/admin-dashboard');
  };

  return (
    <>
      <Tooltip title="Profile">
        <IconButton
          onClick={handleOpenMenu}
          sx={{ ml: 2 }}
          size="large"
        >
          <AccountCircleIcon fontSize="inherit" />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem onClick={handleSettingsClick}>Settings</MenuItem>
      </Menu>
    </>
  );
};

export default Dashboard;
